// AppShell.tsx — The signed-in chrome: topbar + sidenav + the
// active route's content. Mounted exactly once after auth resolves
// 'ready'. Increments bootCounters.layoutMount on its first effect
// pass.

import { useEffect, type ReactNode } from 'react';
import { Topbar } from './Topbar';
import { Sidenav } from './Sidenav';
import { bump } from '@/utils/bootCounters';

interface Props {
  children: ReactNode;
}

export function AppShell({ children }: Props) {
  useEffect(() => {
    bump('layoutMount');
  }, []);
  return (
    <div className="console-page" id="admin-panel">
      <Topbar />
      <div className="console-layout">
        <Sidenav />
        <main id="route-content" className="console-main">
          {children}
        </main>
      </div>
    </div>
  );
}
